module.exports = __webpack_public_path__ + "school/img/shizipeixun.1b3e476e.jpg";